import type {TimeZone} from '@hconnect/common/types'

import {useUpmPlant} from './useUpmPlant'

const getSystemTimezone = (): TimeZone => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const useUpmPlantTimezone = (plantId: string): TimeZone => {
  const upmPlant = useUpmPlant({plantId})
  return upmPlant?.timezone || getSystemTimezone()
}
